<template>
	<div class="tab-pane" :class="{ active: defaultTab, show: defaultTab }" :id="id">
		<div class="p-4 b-b _600 nav-title">Item Details</div>
		<form role="form" class="p-4 col-sm-6">
			<div class="form-group" :class="{ invalid: !valid.field('name') }">
				<label>Item Name</label>
				<input type="text" class="form-control" v-model="item.name" />
			</div>
			<div class="form-group" :class="{ invalid: !(valid.field('ref') && valid.field('ref_char')) }">
				<label>Reference ID</label>
				<input type="text" class="form-control" v-model="item.ref_id" :disabled="item.isScored" />
				<small v-if="!item.isScored" class="form-text text-muted"
					>Reference ID must be unique within this tenant</small
				>
			</div>
			<div class="row">
				<div class="col-4">
					<label class>Active:</label>
					<div class="form-group">
						<label class="ui-switch ui-switch-md theme-accent">
							<input type="checkbox" v-model="item.active" />
							<i></i>
						</label>
					</div>
				</div>

				<div class="col-8">
					<div class="form-group">
						<label>Standards</label>
						<config-standard-search v-model="item.standards" taggable />
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<style scoped>
.invalid {
	color: red;
}
</style>

<script>
import fs from "@/services/FormatService";
import ConfigStandardSearch from "@/components/ConfigStandardSearch";

export default {
	name: "ItemEditDetails",

	props: ["id", "item", "defaultTab", "valid"],

	components: { ConfigStandardSearch },

	data() {
		return {
			fs: fs,
			autoRef: false
		};
	},

	watch: {
		"item.name"() {
			if (this.autoRef && !this.item.isScored) {
				this.item.ref_id = fs.toGoodRefID(this.item.name);
			}
		},
		"item.ref_id"() {
			this.checkAutoRef();
		}
	},

	created() {
		this.checkAutoRef();
	},

	methods: {
		checkAutoRef() {
			let genRef = fs.toGoodRefID(this.item.name);
			this.autoRef = this.item.ref_id == genRef && !this.item.isScored;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/item/ItemEditDetails.vue